var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t"},[_c('div',{staticClass:"timg"},[_c('v-img',{attrs:{"max-height":"300","max-width":"300","src":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }